<template>
  <page
    :back-to="getPreviousUrl"
    :title="`Magazine / Incomes /` + $route.params.id"
    size="is-desktop"
    :loading="report.loading"
  >
    <div v-if="report.data">
      <div class="box">
        <h1 class="title is-5">Pages</h1>
        <b-table class="is-middle" :data="report.data">
          <template slot-scope="props">
            <b-table-column label="#" centered>{{
                props.row.id
              }}
            </b-table-column>
            <b-table-column field="title" label="Magazine">
              <router-link
                :to="'/publishers/' + props.row.publisher_id"
                class="has-text-grey"
                size="is-large"
              >{{ props.row.publisher.name }}
              </router-link> /
              <router-link
                :to="'magazines/' + props.row.magazine_id + '/edit'"
                class="has-text-dark"
                size="is-large"
              >{{ props.row.magazine.name }}</router-link
              >
            </b-table-column>

            <b-table-column label="Price">
              {{ props.row.magazine_price }}
            </b-table-column>
            <b-table-column label="Month">{{
                props.row.month
              }}
            </b-table-column>

            <b-table-column label="Opens">
              {{ props.row.magazine_opens }}
            </b-table-column>

            <b-table-column label="Income Share %">
               {{ props.row.income_percentage }}/{{ 100 - props.row.income_percentage }}
            </b-table-column>

            <b-table-column label="Revenue">
              $ {{  Math.round(props.row.revenue*100)/100 }}
            </b-table-column>


          </template>
        </b-table>
      </div>
    </div>
  </page>
</template>
<script>
export default {
  data() {
    return {
      report: new window.RemoteData(() => {
        return `/admin/api/magazine/incomes/${this.$route.params.id}`;
      }).load(),
    };
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  }
};
</script>
